import React from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import LessonCompleteComponent from './component'
import { MESSAGE } from './constants'

const LessonCompleteContainer = ({ lessonName }) => {
  let message

  if (lessonName) {
    message = MESSAGE(lessonName)
  }

  return <LessonCompleteComponent message={message} />
}

LessonCompleteContainer.propTypes = {
  lessonName: PropTypes.string,
}

const mapStateToProps = ({ player }) => ({
  lessonName: player.title,
})

export default connect(mapStateToProps)(LessonCompleteContainer)
